(function () {
  function init(root) {
    var state = {
      name: 'Golden Opulence',
      size: '60 ml',
      schedule: 'Every month',
      scentCount: 1
    };

    var image = root.querySelector('[data-apsl-current-image]');
    var name = root.querySelector('[data-apsl-current-name]');
    var notes = root.querySelector('[data-apsl-current-notes]');
    var summary = root.querySelector('[data-apsl-summary]');
    var addButton = root.querySelector('[data-apsl-add]');
    var addLabel = root.querySelector('[data-apsl-add-label]');

    function personalizeContextCtas() {
      var params = new URLSearchParams(window.location.search);
      var handle = params.get('product');
      var variantId = params.get('variant');
      if (params.get('source') !== 'pdp' || !handle) return;

      var returnUrl = '/products/' + encodeURIComponent(handle);
      var returnParams = new URLSearchParams();
      if (variantId) returnParams.set('variant', variantId);
      returnParams.set('purchase', 'sub');
      returnUrl += '?' + returnParams.toString() + '#subscription-options';

      root.querySelectorAll('[data-apsl-context-cta]').forEach(function (link) {
        link.href = returnUrl;
      });
    }

    function track(eventName, detail) {
      if (typeof window.apTrack === 'function') window.apTrack(eventName, detail || {}, 'subscription');
    }

    function renderSummary() {
      summary.textContent = state.name + ', ' + state.size + ', ' + state.schedule + ', ' + state.scentCount + (state.scentCount === 1 ? ' scent' : ' scents');
    }

    root.querySelectorAll('[data-apsl-scent]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-apsl-scent]').forEach(function (item) {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        state.name = button.dataset.name;
        image.src = button.dataset.image;
        image.alt = state.name + ' fragrance oil';
        name.textContent = state.name;
        notes.replaceChildren();
        button.dataset.notes.split('|').forEach(function (note) {
          var item = document.createElement('li');
          item.textContent = note;
          notes.appendChild(item);
        });
        renderSummary();
        track('subscription_landing_demo_used', { action: 'scent', scent: state.name });
      });
    });

    root.querySelectorAll('[data-apsl-group]').forEach(function (group) {
      group.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', function () {
          group.querySelectorAll('button').forEach(function (item) {
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
          state[group.dataset.apslGroup] = button.dataset.value;
          renderSummary();
          track('subscription_landing_demo_used', { action: group.dataset.apslGroup, value: button.dataset.value });
        });
      });
    });

    addButton.addEventListener('click', function () {
      state.scentCount = state.scentCount === 1 ? 2 : 1;
      var added = state.scentCount > 1;
      addButton.setAttribute('aria-pressed', added ? 'true' : 'false');
      addButton.firstElementChild.textContent = added ? '✓' : '＋';
      addLabel.textContent = added ? 'Second scent added' : 'Add another scent';
      renderSummary();
      track('subscription_landing_demo_used', { action: 'scent_count', value: state.scentCount });
    });

    root.querySelectorAll('[data-apsl-cta]').forEach(function (link) {
      link.addEventListener('click', function () {
        track('subscription_landing_cta_clicked', { source: link.dataset.apslCta });
      });
    });

    personalizeContextCtas();
  }

  document.querySelectorAll('[data-apsl]').forEach(init);
}());
